import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyB5D-gmK3tnmxXFYzbTU1M_dIDKfz-0c-E",
    authDomain: "setsubiz-photo.firebaseapp.com",
    projectId: "setsubiz-photo",
    storageBucket: "setsubiz-photo.firebasestorage.app",
    messagingSenderId: "223651059744",
    appId: "1:223651059744:web:7cb2ff86b3d3dd9c758445",
    measurementId: "G-ZGZM2HCQVG"
  };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app); 